import modalStyle from "../../modal.module.scss";

import React, { useEffect } from 'react';
import { Box } from "@mui/material";

import { scopeLevelOption } from "../../../const";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

const Operation = (props) => {
  const {
    closeOpenModal, scopeLevel,
    currentStep, totalSteps,
    btnTitle, disabledBtn, callbackFn
  } = props;

  // State

  // Method
  const handleClose = () => {
    if (disabledBtn) {
      return;
    }

    closeOpenModal();
  };

  const adopt = () => {
    if (disabledBtn) {
      return;
    }

    callbackFn();
  };

  if (currentStep === totalSteps) {
    return (
      <>
        <Box className={modalStyle['modal_operation']}>
          <SolidButton
            className={`${modalStyle['modal_saveBtn']} ${disabledBtn ? modalStyle['disabled_btn'] : ''}`}
            disabled={disabledBtn}
            style={{ width: '195px', height: '42px', fontSize: '16px' }}
            variant="contained"
            onClick={handleClose}
          >
            Close
          </SolidButton>
        </Box>
      </>
    )
  }

  return (
    <>
      <Box className={modalStyle['modal_operation']}>
        <OutlineButton
          className={modalStyle['modal_cancelBtn']}
          style={{ width: '195px', height: '42px', fontSize: '16px' }}
          variant="contained"
          onClick={closeOpenModal}
        >
          Cancel
        </OutlineButton>
        <SolidButton
          className={`${modalStyle['modal_saveBtn']} ${disabledBtn ? modalStyle['disabled_btn'] : ''}`}
          disabled={disabledBtn}
          style={{ width: '195px', height: '42px', fontSize: '16px' }}
          variant="contained"
          onClick={adopt}
        >
          {btnTitle}
        </SolidButton>
      </Box>
    </>
  );
}

export default Operation;